const divActionModalFilter = {
  buttonCancel: 'CANCEL',
  button: 'APPLY'
};

export default divActionModalFilter;
